export default __webpack_public_path__ + "static/media/me.930fba5e.jpeg";